import React, { useContext, useEffect } from "react";
import { ModalContext } from "../../context/ModalContext";
import { ClassTypeContext } from "../../context/ClassTypesContext";
import { AuthContext } from "../../context/AuthContext";
import ClassTypeRow from "../../components/classTypes/ClassTypeRow";
import ClassTypeForm from "../../components/classTypes/ClassTypeForm";
import useBranch from "../../hooks/useBranch";

const AdminClassTypes = () => {
  const { class_types, getClassTypes, deleteClassType } =
    useContext(ClassTypeContext);

  const { modalComponent } = useContext(ModalContext);
  const { user } = useContext(AuthContext);

  const { branch_id } = useBranch();

  useEffect(() => {
    getClassTypes();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const createType = () => {
    modalComponent("Agregar Clase", <ClassTypeForm class_type_id="nuevo" />);
  };

  const editClassType = (class_type_id) => {
    modalComponent(
      "Editar Clase",
      <ClassTypeForm class_type_id={class_type_id} />
    );
  };

  const confirmDelete = (class_type) => {
    modalComponent(
      "Eliminar Clase",
      <div>
        <p>
          ¿Estás seguro que deseas eliminar el tipo de clase "{class_type.name}
          "? Esta acción NO puede deshacerse.
        </p>
        <button
          className="btn btn-danger"
          onClick={() => deleteClassType(class_type.class_type_id)}
        >
          <i className="fa fa-trash"></i> Eliminar
        </button>
      </div>
    );
  };

  const renderTipos = () => {
    if (class_types && class_types !== null) {
      const branch_class_types = class_types.filter(
        (class_type) => class_type.branch_id === branch_id
      );
      if (branch_class_types.length === 0) {
        return <p>No hay tipos de clase disponibles.</p>;
      }
      console.log(branch_class_types);
      return branch_class_types.map((category) => (
        <ClassTypeRow
          key={category.class_type_id}
          category={category}
          editClassType={editClassType}
          confirmDelete={confirmDelete}
          userRole={user.role}
        />
      ));
    }
    return <div className="spinner-border"></div>;
  };

  const renderSuperAdminCols = () => {
    if(user.role === 'super_admin') {
      return(
        <td>Acciones</td>
      )
    }
  }

  const renderAddBtn = () => {
    if(user.role === 'super_admin') {
      return(
        <div className="col-12 col-md-6 text-end">
          <button className="btn btn-primary" onClick={createType}>
            + Agregar
          </button>
        </div>
      )
    }
  }

  return (
    <div className="container-fluid">
      <div className="row mb-3 align-items-center">
        <div className="col-12 col-md-6">
          <h1>Tipos de Clase</h1>
        </div>
        {renderAddBtn()}
      </div>
      <div className="table-responsive">
        <table className="table border">
          <thead className="bg-light border bold small">
            <tr className="bold mx-0 border align-items-center">
              <td>Nombre</td>
              <td>Icono</td>
              <td>Color</td>
              <td>Mapa</td>
              {renderSuperAdminCols()}
            </tr>
          </thead>
          <tbody>{renderTipos()}</tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminClassTypes;
